import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/hooks/use-toast'
import { useTranslation } from '@/hooks/use-translation'
import { admin } from '@/lib/auth-client'
import { clearTabOrganization } from '@/lib/tab-organization'

export function useStopImpersonating() {
  const queryClient = useQueryClient()
  const { error } = useToast()
  const t = useTranslation()

  const stopMutation = useMutation({
    mutationFn: async () => {
      const result = await admin.stopImpersonating()
      if (result.error) {
        throw new Error(result.error.message || 'Failed to stop impersonation')
      }
      return result.data
    },
    onSuccess: () => {
      clearTabOrganization({ untilReload: true })
      queryClient.clear()
      window.location.href = '/'
    },
    onError: (err) => {
      console.error('Stop impersonation error:', err)
      error(t('superAdmin.toasts.stopImpersonationError'))
    },
  })

  return {
    stopImpersonating: () => stopMutation.mutateAsync(),
    isStopping: stopMutation.isPending,
    error: stopMutation.error,
  }
}
